import { render, staticRenderFns } from "./OushiDiaoxian.vue?vue&type=template&id=a39e2af8&scoped=true&"
import script from "./OushiDiaoxian.vue?vue&type=script&lang=js&"
export * from "./OushiDiaoxian.vue?vue&type=script&lang=js&"
import style0 from "./OushiDiaoxian.vue?vue&type=style&index=0&id=a39e2af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39e2af8",
  null
  
)

export default component.exports